interface SystemStyles {
  large: string;
  medium: string;
  small: string;
  sectionTitle: string;
  sectionSubtitle: string;
  body: string;
  bodyBold: string;
  navigation: string;
}

const Styles: SystemStyles = {
  large: "large",
  medium: "medium",
  small: "small",
  sectionTitle: "section-title",
  sectionSubtitle: "section-subtitle",
  body: "body",
  bodyBold: "body-bold",
  navigation: "navigation",
};

export default Styles;
